const $ = require('jquery');

const validEmptyImage = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

module.exports = {
  init: function() {
    // Before adding new hover listener, remove others. Should be only 1.
    $('.imagesThumb-image--includesFull').off('mouseenter mouseleave');
    $('.imagesThumb-image--includesFull').hover(
      // mouseenter
      function() {
        const $initialImage = $(this).find('.imagesThumb-centeredImage');
        const $fullImage = $(this).find('.imagesThumb-fullImage');

        $initialImage.css('opacity', 0.3);

        if ($fullImage.attr('src') !== validEmptyImage) {
          $fullImage.show(200);
          return;
        }

        const urlParts = $initialImage.attr('src').split('/');
        for (let i = 0; i < urlParts.length; i++) {
          if (urlParts[i] === 'o-l') {
            urlParts[i] = 'l';
            break;
          }
        }

        $fullImage.attr('src', urlParts.join('/'))
          .bind('load', function() {
            $(this).show(200);
          })
          .bind('error', function() {
            $(this).attr('src', validEmptyImage);
            $fullImage.unbind();
            $initialImage.css('opacity', 0);
          });
      },
      // mouseleave
      function() {
        $(this).find('.imagesThumb-fullImage').unbind();
        $(this).find('.imagesThumb-fullImage').hide(200);
        $(this).find('.imagesThumb-centeredImage').css('opacity', 1);
      }
    );
  }
};
